/**
 * Helpers for grouped StudentFeeLedger (items[] shape).
 */

export const itemTitle = (it) => {
  if (!it) return "—";
  if (typeof it.title === "string" && it.title.trim()) return it.title.trim();
  const head = it.feeHeadId;
  if (head && typeof head === "object" && head.name) return head.name;
  if (typeof it.feeHeadName === "string" && it.feeHeadName) return it.feeHeadName;
  return "—";
};

export const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Expand a ledger document into display rows (one per fee head).
 */
export const expandLedgerItems = (row) => {
  if (!row) return [];
  const items = Array.isArray(row.items) ? row.items.filter(Boolean) : [];

  if (items.length > 0) {
    return items.map((it, idx) => ({
      key: `${row._id}-${it._id || idx}`,
      billTitle: row.title || `${row.month || ""}/${row.year || ""}`,
      headTitle: itemTitle(it),
      amount: num(it.amount),
      discountAmount: num(it.discountAmount),
      fineAmount: num(it.fineAmount),
      netAmount: num(it.netAmount),
      paidAmount: num(it.paidAmount),
      dueAmount: num(it.dueAmount),
      status: it.status || row.status || "PENDING",
      dueDate: row.dueDate,
      isFirst: idx === 0,
      headCount: items.length,
      parentId: row._id,
    }));
  }

  // Legacy single-head doc fallback
  return [
    {
      key: String(row._id),
      billTitle: row.title || `${row.month || ""}/${row.year || ""}`,
      headTitle: itemTitle(row) !== "—" ? itemTitle(row) : row.feeHeadId?.name || "—",
      amount: num(row.amount ?? row.totalAmount),
      discountAmount: num(row.discountAmount ?? row.totalDiscount),
      fineAmount: num(row.fineAmount ?? row.totalFine),
      netAmount: num(row.totalNet ?? row.netAmount),
      paidAmount: num(row.totalPaid ?? row.paidAmount),
      dueAmount: num(row.totalDue ?? row.dueAmount),
      status: row.status || "PENDING",
      dueDate: row.dueDate,
      isFirst: true,
      headCount: 1,
      parentId: row._id,
    },
  ];
};

export const expandLedgerList = (ledger) => {
  if (!Array.isArray(ledger)) return [];
  return ledger.flatMap(expandLedgerItems);
};
